// extracted by mini-css-extract-plugin
module.exports = {"searchInputWrapper":"search_searchInputWrapper__3cuVu","iconWrapper":"search_iconWrapper__Sgxat","resetIcon":"search_resetIcon__2sXZJ"};